import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { ownerBenefits } from "@/mocks/public";

export default function OwnerShowcaseSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="container-page">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <Reveal variant="left" className="relative order-2 lg:order-1">
            <div className="img-zoom w-full h-[320px] md:h-[440px] overflow-hidden rounded-lg border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20a%20modern%20residential%20building%20exterior%20with%20terracotta%20and%20cream%20facade%2C%20palm%20tree%2C%20clear%20sky%2C%20soft%20natural%20light%2C%20minimal%20geometric%20architecture%2C%20warm%20earthy%20tones%2C%20elegant%20composition%2C%20high%20detail&width=1000&height=800&seq=owner-immogest-01&orientation=landscape"
                alt="Immeuble résidentiel moderne géré depuis la plateforme"
                title="Gestion d'immeubles pour propriétaires — ImmoBF"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="float-slow absolute -bottom-5 left-5 hidden items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3 md:flex">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className="ri-key-2-line text-xl" aria-hidden="true" />
              </span>
              <div>
                <p className="text-sm font-heading font-semibold text-foreground-950">Taux d'occupation</p>
                <p className="text-xs text-foreground-600">Suivi en temps réel</p>
              </div>
            </div>
          </Reveal>

          <Reveal variant="right" className="order-1 lg:order-2">
            <span className="inline-flex items-center gap-2 rounded-full border border-secondary-200 bg-secondary-50 px-3 py-1 text-xs font-label font-semibold uppercase tracking-wide text-secondary-800">
              <i className="ri-user-star-line text-[13px]" aria-hidden="true" />
              Propriétaires
            </span>
            <h2 className="mt-4 text-2xl md:text-4xl font-heading font-semibold leading-tight text-foreground-950">
              Pilotez tout votre patrimoine immobilier
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              Que vous possédiez un ou plusieurs immeubles, retrouvez l'ensemble de votre gestion dans un tableau de
              bord unique et clair.
            </p>
            <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {ownerBenefits.map((benefit) => (
                <li key={benefit} className="flex items-start gap-2 text-sm text-foreground-700">
                  <i className="ri-checkbox-circle-line mt-0.5 text-secondary-600" aria-hidden="true" />
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8">
              <Link
                to="/solutions"
                className="group inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-label font-medium text-background-50 hover:bg-primary-600 hover:-translate-y-0.5 transition-all cursor-pointer"
              >
                Découvrir la solution propriétaire
                <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}